import { useEffect, useRef } from "react";
import { X } from "lucide-react";

export function Modal({ title, children, onClose, className = "", backdropClassName = "" }: { title: string; children: React.ReactNode; onClose: () => void; className?: string; backdropClassName?: string }) {
  const dialog = useRef<HTMLElement>(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    dialog.current?.focus();
    function closeTopDialog(event: KeyboardEvent) {
      if (event.key !== "Escape") return;
      const dialogs = document.querySelectorAll<HTMLElement>('[role="dialog"]');
      if (dialogs[dialogs.length - 1] === dialog.current) { event.stopPropagation(); close.current(); }
    }
    document.addEventListener("keydown", closeTopDialog);
    return () => document.removeEventListener("keydown", closeTopDialog);
  }, []);
  return <div className={`modal-backdrop${backdropClassName ? ` ${backdropClassName}` : ""}`} role="presentation" onMouseDown={(event) => { event.stopPropagation(); onClose(); }}>
    <section ref={dialog} tabIndex={-1} className={`modal${className ? ` ${className}` : ""}`} role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
      <header><h2>{title}</h2><button className="icon-button" onClick={onClose} aria-label="Cerrar"><X size={20} /></button></header>
      {children}
    </section>
  </div>;
}
